import React from 'react';
import { X } from 'lucide-react';

interface DemoModalProps {
  showDemo: boolean;
  onClose: () => void;
}

export function DemoModal({ showDemo, onClose }: DemoModalProps) {
  if (!showDemo) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/95 flex flex-col items-center justify-center p-3 sm:p-4" onClick={onClose}>
      <button onClick={onClose} className="self-end mb-2 text-slate-400 hover:text-white transition-colors p-2">
        <X className="h-7 w-7" />
      </button>
      <div className="relative w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
        <div className="rounded-xl sm:rounded-2xl overflow-hidden border border-slate-700 sm:border-2 shadow-2xl shadow-green-500/20">
          <video
            autoPlay
            controls
            playsInline
            className="w-full max-h-[80dvh]"
            src="https://customer-assets.emergentagent.com/job_a3f0bd3f-49f6-4dcf-9526-a7319630dc46/artifacts/yh5089aa_Fitness%20%26%20Nutrition%20Notebook%20-%20All%20in%20One%20Fitness%20App%20with%20AI%20Coach%20%26%20Gym%20Tracker.mp4"
          />
        </div>
      </div>
    </div>
  );
}
